import { LocaleMessages } from '@intlify/core-base';
import { VueMessageType } from 'vue-i18n';

export const it: LocaleMessages<VueMessageType> = {
  message: {
    continue: 'Continua',
    mandatory_field: '* Campo Obbligatorio',
    mandatory_char: ' *',
    email_address: 'Indirizzo email',
    enter_your_email: 'Inserisci la tua email',
    email_placeholder: 'Email',
    birth_day: 'Giorno di nascita',
    birth_month: 'Mese di nascita',
    birth_year: 'Anno di nascita',
    name: 'Nome',
    surname: 'Cognome',
    birthday: 'Data di Nascita',
    birthday_with_format: 'Data di nascita (GG/MM/AAAA)',
    phoneNumber: 'Numero di Cellulare',
    dd: 'GG',
    mm: 'MM',
    yyyy: 'YYYY',
    defaultYearBirthdate: '1980',
    profilingPermission: 'Vivi una esperienza personalizzata',
    marketingPermission: 'Resta aggiornato sul mondo Alpitour World',
    thirdPermission: 'Resta aggiornato sul mondo<br> Neos e VOIhotels',
    register: 'Registrati',
    password: 'Password',
    your_password: 'La tua password',
    signin: 'Accedi',
    error: 'Spiacenti, qualcosa è andato storto, riprova più tardi.',
    forgot_password: 'Dimenticato la password?',
    not_register: 'Non sei registrato?',
    repeat_password: 'Ripeti Password',
    repeat_password_placeholder: 'Ripeti password',
    sign_up_email_sent: 'Il link per confermare la tua registrazione è stato inviato al tuo indirizzo mail {email}. Se non lo ricevi nella tua posta in arrivo, prova a verificare anche nella posta indesiderata. Se dopo qualche minuto non è ancora arrivato il link, ti consigliamo di non ripetere la procedura di iscrizione e di scriverci a area.riservata{\'@\'}alpitourworld.it dove la nostra assistenza sarà felice di aiutarti.',
    confirmation_sign_up_success_message: 'Registrazione completata con successo',
    confirmation_sign_up_error_message: 'Codice di verifica scaduto, account {email} non confermato',
    sign_in_title: 'Accedi o registrati all\'area riservata',
    sign_in_error: 'Riprovare più tardi.',
    sign_in_not_authorized_error: 'Indirizzo mail o password errati',
    sign_in_user_not_found_error: 'Ci dispiace, le tue credenziali non sembrano corrette. Se in passato hai fatto una registrazione, prova ad effettuare l\'accesso tramite l\'utilizzo dei social.',
    sign_in_3_time_limit: 'Ci dispiace qualcosa è andato storto. Ti chiediamo di contattare l\'assistenza scrivendo ad "area.riservata{\'@\'}alpitourworld.it" dettagliando la problematica riscontrata',
    sign_in_try_later_error: 'Riprovare più tardi',
    sign_in_user_not_confirmed_error: 'Controlla le mail per completare il processo di registrazione',
    logout_success: 'Il logout è stato effettuato con successo',
    logout_error: 'Riprovare più tardi',
    sign_up_error: 'Ops, ci sono problemi con la tua registrazione.Riprova o contatta l\'assistenza: Area.riservata{\'@\'}alpitourworld.it',
    send_password: 'Invia password',
    forgot_password_title: 'Recupera Password',
    forgot_password_info: 'Per reimpostare la tua password, inserisci la tua mail e conferma. Ti sarà inviata una mail con le istruzioni per completare il processo',
    forgot_password_success: 'Il link per reimpostare la tua password è stato inviato al tuo indirizzo mail {email}. Se non lo ricevi nella tua posta in arrivo, prova a verificare anche nella posta indesiderata. Se dopo qualche minuto non è ancora arrivato il link, ti consigliamo di non ripetere la procedura di reset password e di scriverci a area.riservata{\'@\'}alpitourworld.it dove la nostra assistenza sarà felice di aiutarti.',
    forgot_password_error: 'Riprovare più tardi',
    forgot_password_try_social: 'Ci dispiace, qualcosa è andato storto. Se in passato hai fatto una registrazione, prova ad effettuare l\'accesso tramite l\'utilizzo dei social.',
    forgot_password_generic_error: 'Ci dispiace, qualcosa è andato storto. Ti chiediamo di riprovare più tardi.',
    restore_password: 'Conferma',
    reset_password_title: 'Reimposta Password',
    reset_password_success: 'La password è stata reimpostata con successo',
    reset_password_error: 'Codice di verifica scaduto, cambio password fallito',
    reset_password_required: 'É necessario reimpostare la password',
    confirm_password: 'Conferma',
    user_already_exists_error: 'Risulti già registrato con questa mail, prova ad accedere o a recuperare la tua password',
    date_format: '{year}-{month}-{day}',
    invalid_birthdate: 'Data di nascita invalida',
    invalid_phone_number: 'Numero di telefono già utilizzato',
    registration_title: 'Registrazione a MyAlpitourWorld',
    complete_federated_login_title: 'Completa la tua Registrazione',
    invalid_password: 'Password non valida',
    password_policy_title: 'Deve contenere almeno:',
    password_policy_spaces: 'Nessuno spazio iniziale o finale',
    password_policy_length: '8 caratteri',
    password_policy_lowercase: '1 carattere minuscolo',
    password_policy_uppercase: '1 carattere maiuscolo',
    password_policy_number: '1 carattere numerico',
    password_policy_special: '1 carattere speciale',
    under_age: 'Devi essere maggiorenne per procedere con la registrazione',
    or_access_with: 'Oppure accedi con',
    sign_up_privacy_policy: 'Dichiaro, inoltre, di aver preso visione dell’ <a class="underline font-bold" style="color:{color}" target="_blank" href="{privacyUrl}">informativa privacy</a>.',
    sign_up_general_conditions: 'Con la registrazione all’area riservata accetto: <br> le <a class="underline font-bold" style="color:{color}" target="_blank" href="{generalConditionsUrl}">condizioni generali</a>&nbsp',
    sign_up_vexatious_clauses: 'e le clausole vessatorie.&nbsp',
    marketing_consent_description_not_expanded: 'Acconsento al trattamento dei dati personali per finalità di marketing diretto con strumenti automatizzati e non automatizzati',
    marketing_consent_description_expanded: 'Acconsento al trattamento dei miei dati personali per l’invio, con strumenti automatizzati (e-mail; telefono senza operatore -es. sms, mms, notifiche push) e non automatizzati (posta cartacea; telefono con operatore), di newsletter e comunicazioni promozionali sui prodotti e sulle iniziative di Alpitour e di soggetti terzi che propongono servizi turistici e/o servizi turistici integrativi, comprese le altre Società del Gruppo Alpitour, incluse quelle finalizzate alla conduzione di ricerche di mercato e alla partecipazione a manifestazioni a premio ed eventi organizzati da Alpitour e dai soggetti terzi sopra menzionati',
    profiling_consent_description_not_expanded: 'Acconsento al trattamento dei dati personali per finalità di profilazione e invio di comunicazioni personalizzate',
    profiling_consent_description_expanded: 'Acconsento al trattamento dei miei dati personali per analizzare il dettaglio degli acquisti, (es. tipi di strumenti di pagamento, le mie risposte a ricerche di mercato, il volume acquisti, le destinazioni di viaggio ecc.) e/o il comportamento di navigazione e di utilizzo della piattaforma, dei siti e dell’Applicazione, al fine di definire un profilo delle mie preferenze, per finalità statistiche e/o commerciali e di marketing',
    third_consent_description_not_expanded: 'Acconsento alla comunicazione dei miei dati personali alle altre società del Gruppo Alpitour per finalità di marketing',
    third_consent_description_expanded: 'Acconsento alla comunicazione dei miei dati personali alle altre società del Gruppo Alpitour per finalità di invio, con strumenti automatizzati, di newsletter e comunicazioni promozionali sui propri prodotti e iniziative (l’elenco delle società del Gruppo destinatarie della comunicazione è disponibile sul sito web del Titolare – area privacy)',
    read_more: 'Leggi tutto',
    hide: 'Nascondi',
    sign_in_privacy_terms: 'Leggi l\'<a class="underline font-bold" style="color:{color}" target="_blank" href="{privacyUrl}">informativa privacy</a>&nbsp',
    sign_in_general_conditions: 'e le <a class="underline font-bold" style="color:{color}" target="_blank" href="{generalConditionsUrl}">condizioni generali</a>',
    hat_trick_message: 'Risulti già registrato ma con una diversa mail',
    crm_existing_email: 'Risulti già registrato con questa mail, prova ad accedere o a recuperare la tua password',
    crm_phone_not_allowed: 'Il numero inserito non è valido. Verifica di non includere il prefisso internazionale (selezionalo dal menu a tendina). Per assistenza: area.riservata{\'@\'}alpitourworld.it',
    crm_phone_used: 'Il numero è già associato a un altro profilo. Riprova senza inserirlo. Per supporto: area.riservata{\'@\'}alpitourworld.it',
    crm_phone_not_congruent: 'Il numero risulta registrato ma non corrisponde ai dati anagrafici forniti. Riprova senza inserirlo. Per assistenza: area.riservata{\'@\'}alpitourworld.it',
    crm_incongruent_data: 'Il numero digitato non è valido. Verifica di non includere il prefisso internazionale. Per supporto: area.riservata{\'@\'}alpitourworld.it',
    otp_page_title: 'Verifica il tuo account con OTP',
    select_otp_type: 'Seleziona il metodo di autenticazione',
    otp_send_mail: 'Verrà inviata una mail a',
    otp_send_phone: 'Verrà inviato un sms al numero',
    insert_otp: 'Inserisci il codice ricevuto via ',
    send_otp_error: 'Si è verificato un errore durante l\'invio del codice OTP! Se il problema persiste contattare l\'assistenza: Area.riservata{\'@\'}alpitourworld.it',
    confirm_otp_error: 'Si è verificato un errore durante la conferma del codice OTP! Se il problema persiste contattare l\'assistenza: Area.riservata{\'@\'}alpitourworld.it',
    otp_code: 'Codice OTP',
    email: 'E-mail',
    phone: 'Telefono',
    get_user_contacts: 'Si è verificato un errore durante il recupero dei contatti associati alla tua utenza! Se il problema persiste contattare l\'assistenza: Area.riservata{\'@\'}alpitourworld.it',
    otp_duration: 'Il codice ha durata 15 minuti',
    back_to_login: 'Torna alla login',
    unknown_contacts: 'Se non riconosci i contatti suggeriti, potrebbero essere della tua Agenzia di Viaggio di fiducia',
    otp_support: 'Stai avendo problemi a recuperare il tuo account? Scrivi ad "area.riservata{\'@\'}alpitourworld.it" per avere assistenza',
    send_again: 'Invia di nuovo',
    // Accessibility
    accessibility: {
      email_required: 'Inserisci un indirizzo email valido',
      registration_email_required: 'Inserisci un indirizzo email valido',
      email_invalid: 'Inserisci un indirizzo email valido',
      name_required: 'Nome obbligatorio',
      registration_name_required: 'Inserisci il nome',
      name_invalid: 'Nome non valido',
      name_min_length: 'Il nome deve contenere almeno 2 lettere',
      surname_required: 'Cognome obbligatorio',
      registration_surname_required: 'Inserisci il cognome',
      surname_invalid: 'Cognome non valido',
      surname_min_length: 'Il cognome deve contenere almeno 2 lettere',
      birthdate_missing: 'Data di nascita mancante',
      registration_birthdate_required: 'Inserisci la data di nascita',
      password_required: 'Inserisci la password',
      registration_password_required: 'Inserisci la password',
      password_invalid: 'Password non valida: controlla i requisiti',
      confirm_password_required: 'Conferma password obbligatoria',
      passwords_not_match: 'Le password non corrispondono',
      phone_required: 'Numero di telefono obbligatorio',
      registration_phone_required: 'Inserisci il numero di cellulare',
      fix_errors: 'Correggi i seguenti errori: {errors}',
      form_complete: 'Il modulo è ora completo. Puoi procedere con la registrazione.',
      field_valid: '{field} valido',
      password_valid: 'Password valida',
      password_requirements_missing: 'Requisiti mancanti: {requirements}',
      requirement_met: 'soddisfatto',
      requirement_not_met: 'non soddisfatto',
      password_requirements_label: 'Requisiti password',
      password_requirements_list: 'Lista requisiti password',
      progress_label: '{current} requisiti su {total} soddisfatti',
      password_requirements: 'Requisiti password',
      login_with_facebook: 'Accedi con Facebook',
      login_with_google: 'Accedi con Google',
      login_with_apple: 'Accedi con Apple',
      go_back: 'Torna indietro',
      show_password: 'Mostra password',
      hide_password: 'Nascondi password',
      forgot_password: 'Vai alla pagina di recupero password',
      brand_logo_named: 'Logo {brand}',
      brand_logo: 'Logo del brand'
    }
  }
};
